import { setupScript } from '@tools/utils/script-utils';
import { makeAutoObservable } from 'mobx';
import { component } from 'tsdi';

import { stepsContent } from './steps-data';
@component
export class SignupStore {
    public activeStep = 0;
    public tenantURL = '';

    constructor() {
        makeAutoObservable(this);
        this.init();
    }

    public setTenantURL = (url: string) => {
        this.tenantURL = url;
    };

    public goToNextStep = () => {
        if (this.activeStep === stepsContent.length - 1) {
            return;
        }
        this.activeStep++;
    };

    public goToPreviousStep = () => {
        if (this.activeStep === 0) {
            return;
        }
        this.activeStep--;
    };

    protected init(): void {
        setupScript(
            'https://cdn.cookie-script.com/s/0b638f56924bdf61072e77331ee8bb56.js'
        );
    }

    public addtrackingProps = (props: Record<string, string | undefined>) => {
        window.dataLayer.push({
            ...props
        });
    };

    public sendEvent = (
        eventName: string,
        rest?: Record<string, string | undefined>
    ) => {
        window.dataLayer.push({
            event: eventName,
            ...rest
        });
    };
}
